// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"styles_thumbnail__2TO0w","menu":"styles_menu__1Nnno"};